import { Container } from "@components/ui/Container";
import { Section } from "@components/ui/Section";
import { branches, company } from "@data/company";
import { ContactForm } from "./ContactForm";
import styles from "./Contact.module.css";

const IconWhatsapp = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="currentColor" aria-hidden>
    <path d="M17.5 14.4c-.3-.2-1.8-.9-2.1-1s-.5-.2-.7.2c-.2.3-.8 1-1 1.2-.2.2-.4.2-.7.1-.3-.2-1.3-.5-2.5-1.5-.9-.8-1.5-1.8-1.7-2.1-.2-.3 0-.5.1-.6.1-.1.3-.4.5-.6.2-.2.2-.3.3-.5.1-.2 0-.4 0-.6 0-.2-.7-1.7-1-2.3-.3-.6-.5-.5-.7-.5h-.6c-.2 0-.5.1-.8.4s-1.1 1.1-1.1 2.7c0 1.6 1.1 3.1 1.3 3.3.2.2 2.3 3.5 5.5 4.9.8.3 1.4.5 1.8.7.8.2 1.5.2 2 .1.6-.1 1.8-.7 2-1.5.2-.7.2-1.4.2-1.5-.1-.1-.3-.2-.6-.4zm-5.4 7.4h-.1c-1.8 0-3.5-.5-5.1-1.4l-.4-.2-3.8 1 1-3.7-.2-.4c-1-1.6-1.5-3.5-1.5-5.4 0-5.6 4.5-10 10-10 2.7 0 5.2 1 7.1 2.9 1.9 1.9 2.9 4.4 2.9 7.1.1 5.4-4.3 9.9-9.9 9.9zm8.5-18.5C18.6 1.2 15.4 0 12.1 0 5.5 0 .1 5.4.1 12c0 2.1.5 4.1 1.6 5.9L0 24l6.3-1.6c1.7.9 3.6 1.4 5.6 1.4h.1c6.6 0 12-5.4 12-12 0-3.2-1.2-6.2-3.5-8.5z" />
  </svg>
);

const IconPhone = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IconMail = () => (
  <svg viewBox="0 0 24 24" width={22} height={22} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <rect x="3" y="5" width="18" height="14" rx="2" />
    <path d="m3 7 9 6 9-6" />
  </svg>
);

const IconPin = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M21 10c0 7-9 13-9 13s-9-6-9-13a9 9 0 0 1 18 0z" />
    <circle cx="12" cy="10" r="3" />
  </svg>
);

const IconPhoneSmall = () => (
  <svg viewBox="0 0 24 24" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M22 16.92v3a2 2 0 0 1-2.18 2 19.79 19.79 0 0 1-8.63-3.07 19.5 19.5 0 0 1-6-6 19.79 19.79 0 0 1-3.07-8.67A2 2 0 0 1 4.11 2h3a2 2 0 0 1 2 1.72 12.84 12.84 0 0 0 .7 2.81 2 2 0 0 1-.45 2.11L8.09 9.91a16 16 0 0 0 6 6l1.27-1.27a2 2 0 0 1 2.11-.45 12.84 12.84 0 0 0 2.81.7A2 2 0 0 1 22 16.92z" />
  </svg>
);

const IconClock = () => (
  <svg viewBox="0 0 24 24" width={18} height={18} fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <circle cx="12" cy="12" r="10" />
    <path d="M12 6v6l4 2" />
  </svg>
);

const IconArrow = () => (
  <svg viewBox="0 0 16 16" width={14} height={14} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden>
    <path d="M3 8h10M9 4l4 4-4 4" />
  </svg>
);

const waUrl = `https://wa.me/${company.whatsapp}?text=${encodeURIComponent(
  "Hola, quiero una cotización",
)}`;

export function Contact() {
  return (
    <Section
      id="contacto"
      align="center"
      eyebrow="Contacto"
      title="Hablemos. Elegí el canal que prefieras"
      description="Te respondemos en menos de 24 horas hábiles. Si necesitás algo urgente, escribinos por WhatsApp."
    >
      <Container>
        <div className={styles.channels}>
          <a
            className={`${styles.channel} ${styles.channelFeatured}`}
            href={waUrl}
            target="_blank"
            rel="noopener"
            aria-label="Contactar por WhatsApp"
          >
            <span className={styles.badge}>Recomendado</span>
            <div className={styles.channelHeader}>
              <div className={`${styles.channelIcon} ${styles.channelIconWa}`}>
                <IconWhatsapp />
              </div>
              <div>
                <div className={styles.channelName}>WhatsApp</div>
                <div className={styles.channelMeta}>Respuesta inmediata</div>
              </div>
            </div>
            <p className={styles.channelBody}>
              Conversá con un productor sin esperas. La forma más rápida de cotizar.
            </p>
            <span className={styles.channelArrow}>
              Iniciar chat <IconArrow />
            </span>
          </a>

          <a
            className={styles.channel}
            href={`tel:${company.phone.replace(/\s/g, "")}`}
            aria-label={`Llamar al ${company.phone}`}
          >
            <div className={styles.channelHeader}>
              <div className={styles.channelIcon}>
                <IconPhone />
              </div>
              <div>
                <div className={styles.channelName}>Teléfono</div>
                <div className={styles.channelMeta}>En horario de oficina</div>
              </div>
            </div>
            <p className={styles.channelBody}>
              <span className={styles.channelValue}>{company.phone}</span>
              <br />
              <span className={styles.channelValue}>{company.phoneAlt}</span>
            </p>
            <span className={styles.channelArrow}>
              Llamar ahora <IconArrow />
            </span>
          </a>

          <a
            className={styles.channel}
            href={`mailto:${company.email}`}
            aria-label={`Escribir a ${company.email}`}
          >
            <div className={styles.channelHeader}>
              <div className={styles.channelIcon}>
                <IconMail />
              </div>
              <div>
                <div className={styles.channelName}>Email</div>
                <div className={styles.channelMeta}>Respuesta en 24 h</div>
              </div>
            </div>
            <p className={styles.channelBody}>
              <span className={styles.channelValue}>{company.email}</span>
              <br />
              Para consultas con documentación o anexos.
            </p>
            <span className={styles.channelArrow}>
              Escribir <IconArrow />
            </span>
          </a>
        </div>

        <div className={styles.grid}>
          <ContactForm />

          <aside className={styles.sidebar}>
            <div className={styles.sidebarBlock}>
              <h3>Sucursales y horarios</h3>
              <div className={styles.branches}>
                {branches.map((branch) => (
                  <div key={branch.name} className={styles.branchWrap}>
                    <a
                      className={styles.branch}
                      href={branch.mapUrl}
                      target="_blank"
                      rel="noopener"
                    >
                      <div className={styles.branchIcon}>
                        <IconPin />
                      </div>
                      <div className={styles.branchInfo}>
                        <span className={styles.branchName}>{branch.name}</span>
                        <span className={styles.branchAddr}>
                          {branch.address}, {branch.city}
                        </span>
                      </div>
                    </a>
                    {branch.phone && branch.phoneDial && (
                      <a
                        className={styles.branchPhone}
                        href={`tel:${branch.phoneDial}`}
                        aria-label={`Llamar a ${branch.name}: ${branch.phone}`}
                      >
                        <IconPhoneSmall />
                        {branch.phone}
                      </a>
                    )}
                    {branch.hours && (
                      <div className={styles.branchHours}>
                        <div className={styles.branchHoursRow}>
                          <IconClock />
                          <div>
                            <div><strong>Lunes a viernes</strong> · {branch.hours.weekdays}</div>
                            {branch.hours.saturday && (
                              <div><strong>Sábados</strong> · {branch.hours.saturday}</div>
                            )}
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                ))}
              </div>
            </div>
          </aside>
        </div>
      </Container>
    </Section>
  );
}
